<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="mb-1 block text-xs font-medium text-background-fg/70"
    >
      {{ label }}
    </label>
    <BasePercentageInput
      :model-value="inputValue"
      :has-error="hasError"
      class="mb-1"
      :highlight="highlight"
      :min="min"
      @update:model-value="handleChange"
    />
    <template v-if="hasError">
      <p class="mt-1 text-xs font-medium text-error">
        {{ errorMessage }}
      </p>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"
const props = withDefaults(
  defineProps<{
    name: string
    label: string
    placeholder?: string
    highlight?: boolean
    min?: number
  }>(),
  {
    modelValue: null,
    type: "text",
    placeholder: "",
    min: undefined,
  }
)

const {
  value: inputValue,
  errorMessage,
  handleChange,
} = useField<number>(toRef(props, "name"), undefined)

const hasError = computed(() => !!errorMessage.value)
</script>
